<template>
    <div>
        <b-container>
            <b-row align-h="center">
                <b-col cols="8">
                    <b-card-group deck>
                        <b-card header="Configure the FCS Integration" header-tag="header">
                            <b-container>
                                <b-row align-h="center">
                                    <b-col cols="8">
                                        <b-form @submit.prevent="updateFCS">
                                            <b-form-group
                                                id="input-group-1"
                                                label="Enter your FCS Master ID"
                                                label-for="fcsMasterId">
                                                <b-form-input
                                                    id="fcsMasterId"
                                                    v-model="masterId"
                                                    type="text"
                                                    placeholder="FCS Master ID">
                                                </b-form-input>
                                            </b-form-group>

                                            <b-form-group
                                                id="input-group-2"
                                                label="Enter your FCS User ID"
                                                label-for="fcsUserId">
                                                <b-form-input
                                                    id="fcsUserId"
                                                    v-model="userId"
                                                    type="text"
                                                    placeholder="FCS User ID">
                                                </b-form-input>
                                            </b-form-group>

                                            <b-form-group
                                                id="input-group-3"
                                                label="Enter your FCS Password"
                                                label-for="fcsPassword">
                                                <b-form-input
                                                    id="fcsPassword"
                                                    v-model="password"
                                                    type="text"
                                                    placeholder="FCS Password">
                                                </b-form-input>
                                            </b-form-group>

                                            <b-form-group
                                                id="input-group-4"
                                                label="FCS Custom Endpoint"
                                                label-for="fcsEndPoint">
                                                <b-form-input
                                                    id="fcsEndPoint"
                                                    v-model="endPoint"
                                                    type="text"
                                                    placeholder="FCS Custom EndPoint">
                                                </b-form-input>
                                            </b-form-group>

                                            <b-button :disabled="isLoading" type="submit" variant="primary">
                                                Save
                                                <i v-if="isLoading"
                                                   class="fa fa-spin fa-spinner text-grey-darkest"
                                                   aria-hidden="true">
                                                </i>
                                            </b-button>
                                        </b-form>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        name   : 'fcs-integration',
        props  : ['fcsMasterId', 'fcsUserId', 'fcsPassword', 'fcsEndPoint'],
        data() {
            return {
                masterId : this.fcsMasterId,
                userId   : this.fcsUserId,
                password : this.fcsPassword,
                endPoint : this.fcsEndPoint,
                isLoading: false,
            }
        },
        methods: {
            updateFCS() {
                const Toast = Swal.mixin({
                    toast            : true,
                    position         : 'top-end',
                    showConfirmButton: false,
                    timer            : 2000
                });

                this.isLoading = true;

                axios.post(route('api.settings.fcs'),
                    {
                        masterId: this.masterId,
                        userId  : this.userId,
                        password: this.password,
                        endPoint: this.endPoint,
                    }).then(() => {
                    Toast.fire({
                        type : 'success',
                        title: "Your FCS Integration has been updated."
                    });
                }).catch(() => {
                    Toast.fire({
                        type : 'error',
                        title: "Error on update your FCS Integration."
                    });
                }).finally(() => {
                    this.isLoading = false;
                })
            },
        }
    }
</script>
